module.exports = __webpack_public_path__ + "img/ic-eye-open.7c2f4f18.svg";